import React from 'react'

import { useState, useRef, useLayoutEffect, useEffect } from "react"
import '../components/gc_service_cat.css'

import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from "gsap";

gsap.registerPlugin();
gsap.registerPlugin(ScrollTrigger);


export const AccordianItem = ({ title, items, onImgLoad }) => {
    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef(null);
    const [height, setHeight] = useState(0);


    const changeNewToggle = () => {
        setIsOpen((prev) => !prev)

        setTimeout(onImgLoad, 700)

    }

    useLayoutEffect(() => {
        if (isOpen) {
            setHeight(contentRef.current.scrollHeight);
        }
        else {
            setHeight(0);
        }   


       
       
    }, [isOpen]);


    return (
        
        <div className="accordion-item">
        
            <button
                className="accordion-header"
                onClick={() =>  changeNewToggle()}
                // aria-expanded={isOpen}
            >
                <span>{title}</span>
                <span className={`icon ${isOpen && "open"}`}></span>
            </button>

            <div
                ref={contentRef}
                className="accordion-content"
                style={{
                    height: `${height}px`,
                    overflow: "hidden",
                    transition: "height 0.3s ease"
                }}
            >
                <ul>
                    {items.map((item3, index3) =>
                    (
                        <li key={index3}><span className="opacity-60">{item3}</span></li>
                    ))}
                </ul>
            </div>

        </div>
    )
}


const GC_Service_Cat = (prop) => {


    const [openIndexes, setOpenIndexes] = useState([]);
    const contentRefs = useRef([]);

    const items = [
        {
            title: "What services do you offer?",
            content: "We design and develop corporate, business, and marketing websites."
        },
        {
            title: "Do you provide custom solutions?",
            content: "Yes, all solutions are custom-built to match business goals."
        },
        {
            title: "How long does a project take?",
            content: "Project timelines depend on scope, complexity, and requirements."
        }
    ];

    const toggleItem = (index) => {

        setOpenIndexes((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );

        setTimeout(prop.onImgLoad, 700)
    };

    useLayoutEffect(() => {

        {


            const servicesObj = document.querySelectorAll('.service-box-wrapper');
            servicesObj.forEach((item, i) => {

                const content = item.querySelector('.content')

                let img = "";
                item.querySelectorAll('img').length ? img = item.querySelectorAll('img') : img = item.querySelectorAll('video')






                const tl = gsap.timeline(
                    {
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 70%',
                            end: 'center 80%',
                            scrub: 1,
                            markers: false,

                        },
                    });

                tl.fromTo(content.querySelectorAll("div"),
                    {
                        opacity: 0,
                        y: 100
                    },
                    {
                        opacity: 1,
                        y: 0,
                        stagger: .08

                    }, 0);

                const tlImage = gsap.timeline(
                    {
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 100%',
                            end: 'center 60%',
                            scrub: 1,
                            markers: false,

                        },
                    });
                tlImage.fromTo(img,
                    {

                        clipPath: "inset(50% 50% 50% 50%)",

                    },
                    {

                        clipPath: "inset(0% 0% 0% 0%)",

                    }, 0);






            });

        }


        return () => {
            ScrollTrigger.killAll();
        };

    });

    return (
        <section className='page-services services'>
            <div className="container">

                {
                    prop.subServices.map((item, index) => (
                        <div key={index} className="service-box-wrapper">
                            {/* <div className='service-box-header'>
                                    <div className="center">
                                        <div className="overlay-left"></div>
                                        <div className="overlay-right"></div>
                                        <div className="marquee-sub-service-wrapper">
                                            <div className='marquee-sub-service'>
                                                <div>{prop.marqueeText}</div>
                                                <div>*</div>
                                                <div>{prop.marqueeText}</div>
                                                <div>*</div>
                                                <div>{prop.marqueeText}</div>
                                                <div>*</div>
                                                <div>{prop.marqueeText}</div>
                                                <div>*</div>
                                            </div>
                                            <div className='marquee-sub-service'>
                                                <div>{prop.marqueeText}</div>
                                                <div>*</div>
                                                <div>{prop.marqueeText}</div>
                                                <div>*</div>
                                                <div>{prop.marqueeText}</div>
                                                <div>*</div>
                                                <div>{prop.marqueeText}</div>
                                                <div>*</div>
                                            </div>


                                        </div>


                                    </div>
                                </div> */}



                            <div className='service-box-content ' style={{ flexDirection: index % 2 === 1 ? 'row-reverse' : 'row' }}>

                                <div className='xl:w-1/2 md:hidden mb-10 services-image' >

                                    {item.imageURL && (<img src={item.imageURL} onLoad={prop.onImgLoad} alt={item.title} width="100" height="auto " />)}
                                    {item.videoURL && (<video autoPlay="" muted playsInline controlsList="nodownload noplaybackrate noremoteplayback" disablePictureInPicture="">
                                        <source src={item.videoURL + '.webm'} type="video/webm" />
                                        <source src={item.videoURL + '.mp4'} type="video/mp4" />
                                    </video>)}

                                </div>

                                <div className={`xl:w-1/2 content ${index % 2 === 1 ? 'contentPaddingLeft' : 'contentPaddingRight'} `}>
                                    <div className="pill text-primary">{prop.marqueeText}</div>
                                    <div className="hh3 ">{item.title}</div>
                                    <div>
                                        <p className="opacity-50" style={{ whiteSpace: 'pre-line' }} >{item.desc}</p>
                                    </div>

                                    <div className="mt-10 mb-10">
                                        <div className="accordion">
                                            {
                                                item.accordian.map((item2, myKey) =>
                                                    (<AccordianItem key={myKey} title={item2.title} items={item2.desc} onImgLoad={prop.onImgLoad} />))

                                            }

                                            {

                                                // item.accordian.map((item2, index2) => {
                                                //     const isOpen = openIndexes.includes(index.toString() + index2);

                                                //     return (
                                                //         <div key={index2} className="accordion-item">
                                                //             <button
                                                //                 className="accordion-header"
                                                //                 onClick={() => toggleItem(index.toString() + index2)}
                                                //                 aria-expanded={isOpen}
                                                //             >
                                                //                 <span>{item2.title}</span>
                                                //                 <span className={`icon ${isOpen && "open"}`}></span>
                                                //             </button>


                                                //             <div
                                                //                 ref={(el) => (contentRefs.current[index.toString() + index2] = el)}
                                                //                 className="accordion-content"
                                                //                 style={{
                                                //                     height: isOpen
                                                //                         ? `${contentRefs.current[index.toString() + index2]?.scrollHeight}px`
                                                //                         : "0px",
                                                //                     overflow: "hidden",
                                                //                     transition: "height 0.3s ease"
                                                //                 }}
                                                //             >
                                                //                 <ul>
                                                //                     {item2.desc.map((item3, index3) =>
                                                //                     (
                                                //                         <li key={index3}><span className="opacity-60">{item3}</span></li>
                                                //                     ))}
                                                //                 </ul>
                                                //             </div>
                                                //         </div>
                                                //     );
                                                // })
                                            }
                                        </div>



                                    </div>
                                </div>
                                <div className={`xl:w-1/2  mt-10 xl:mt-0 hidden md:flex ${index % 2 === 1 ? 'contentPaddingRight' : 'contentPaddingLeft'} `}>
                                    {/* <img src={item.imageURL} className="rounded-2xl" onLoad={prop.onImgLoad}/> */}




                                    {item.videoURL ? (


                                                <video 
                                                autoPlay 
                                                muted 
                                                loop 
                                                playsInline
                                                controlsList="nodownload noplaybackrate noremoteplayback" 
                                                style={{ clipPath: 'inset(1.9001%)' }}
                                                >
                                                <source src={item.videoURL + '.webm'} type="video/webm" />
                                                <source src={item.videoURL + '.mp4'} type="video/mp4" />
                                                </video>


                                    
                                    ) : (
                                        <img src={item.imageURL} alt={item.title} width="100%" />
                                    )}
                                </div>
                            </div>


                        </div>

                    ))

                }


            </div>
        </section>

    )
}

export default GC_Service_Cat
